export enum AssetFileType {
  FILE_ORIGINAL = 'file_original',
  PREVIEW_DEFAULT = 'preview_default',
  PREVIEW_THUMBNAIL = 'preview_thumbnail',
  PREVIEW_QUANTIZED = 'preview_quantized',
}
